export const STEPS = {
  INFO: 'info',
  BUILD: 'build',
}
